import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const managementUrl = `${apiMainUrl}management`;

const auth = token => ({ headers: { Authorization: `Bearer ${token}` } });

const compactParams = params => Object.fromEntries(
  Object.entries(params || {}).filter(([, value]) => value !== '' && value !== null && value !== undefined)
);

const resource = path => ({
  list: async (params, token) => (await axios.get(`${managementUrl}/${path}`, {
    ...auth(token), params: compactParams(params)
  })).data,
  create: async (body, token) => (await axios.post(`${managementUrl}/${path}`, body, auth(token))).data,
  update: async (id, body, token) => (await axios.put(`${managementUrl}/${path}/${id}`, body, auth(token))).data,
  remove: async (id, token) => (await axios.delete(`${managementUrl}/${path}/${id}`, auth(token))).data,
  importFile: async (file, companyId, token) => {
    const data = new FormData();
    data.append('file', file);
    if (companyId) data.append('companyId', String(companyId));
    return (await axios.post(`${managementUrl}/${path}/import`, data, auth(token))).data;
  },
  configure: async (id, provider, body, token) => (
    await axios.put(`${managementUrl}/${path}/${id}/connections/${provider}`, body, auth(token))
  ).data
});

export const ManagementDataService = {
  companies: resource('companies'),
  institutions: resource('financial-institutions'),
  accounts: resource('financial-accounts'),
  cards: resource('payment-cards'),
  bankServices: async token => (await axios.get(`${apiMainUrl}bank-config/bank-services`, auth(token))).data
};

export const rowsFromResponse = response => {
  if (Array.isArray(response)) return response;
  return response?.items ?? response?.data ?? response?.results ?? [];
};

export const problemMessage = (error, fallback = 'The request could not be completed.') => {
  const problem = error?.response?.data;
  if (typeof problem === 'string') return problem;
  if (problem?.title) return problem.title;
  return error?.message || fallback;
};
